/* global window */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// components
import CardTitlePart from '../../parts/CardTitlePart';
import TextCTA from '../../layout/buttons/TextCTA';
import HtmlPart from '../../parts/HtmlPart';
import CardBannerPart from '../../parts/CardBannerPart';
import TextLoadingDots from '../../layout/graphics/TextLoadingDots';

// services
import { makeSafe } from '../../services/cloudinaryService';
import { getDeliveryInfo } from '../../services/orderService';
import { gtmCardEvent } from '../../services/gtmService';

const GTM_SWITCH = {
  'Delivery Today': 'delivery-today',
  'Delivery Tomorrow': 'delivery-tomorrow',
};

class _DeliveryNoticeCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      deliveryInfo: false,
      deliveryInfoError: false
    };
    this.handleVideoRestart = this.handleVideoRestart.bind(this);
    this.renderCTA = this.renderCTA.bind(this);
    this.renderVideoRestartCTA = this.renderVideoRestartCTA.bind(this);
    this.renderLinkCTA = this.renderLinkCTA.bind(this);
    this.renderExpanderCTA = this.renderExpanderCTA.bind(this);
    this.getDeliveryInfo = this.getDeliveryInfo.bind(this);
    this.expandCard = this.expandCard.bind(this);
    this.captureBannerVideoClick = this.captureBannerVideoClick.bind(this);

    this.CTA_TYPES = {
      expander: this.renderExpanderCTA,
      link: this.renderLinkCTA,
      videoRestart: this.renderVideoRestartCTA
    };
  }

  componentDidMount() {
    this.getDeliveryInfo();
  }

  getDeliveryInfo() {
    const { orderIdx, userGuid } = this.props;
    getDeliveryInfo(orderIdx, userGuid)
      .then(info => this.setState({
        deliveryInfo: info
      }))
      .catch((() => this.setState({ deliveryInfoError: true })));
  }

  handleVideoRestart() {
    this.bannerPart.restartVideo();
  }

  expandCard() {
    const gtmEvent = GTM_SWITCH[this.props.CardName];
    if(gtmEvent && !this.state.expanded) {
      gtmCardEvent(gtmEvent, 'click-view-more')();
    }
    this.setState({ expanded: !this.state.expanded });
  }

  renderCTA(type, text, ctaLink, ctaTextAlt) {
    return this.CTA_TYPES[type](text, ctaLink, ctaTextAlt);
  }

  renderVideoRestartCTA() {
    const { ctaText } = this.props;
    return (
      <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          onBtnClick={this.handleVideoRestart}
          text={ctaText}
          type={'confirm'}
        />
      </div>
    );
  }

  renderExpanderCTA() {
    const { ctaText, ctaTextAlt } = this.props;
    const { expanded } = this.state;
    const alternateText = ctaTextAlt || ctaText;
    return (
      <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          onBtnClick={this.expandCard}
          text={expanded ? alternateText : ctaText}
          type={expanded ? 'shrink' : 'expand'}
        />
      </div>
    );
  }

  renderLinkCTA() {
    const { ctaText, ctaLink = '#' } = this.props;
    return (
      <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          onBtnClick={() => window.location.replace(makeSafe(ctaLink))}
          text={ctaText}
          type={'confirm'}
        />
      </div>
    );
  }

  renderDeliveryInfo() {
    const { deliveryInfo, deliveryInfoError } = this.state;
    const { orderRef, orderNo } = this.props;
    if(deliveryInfoError)
      return 'Sorry we couldnt find your delivery details, if this continues feel free to drop us a message on chat.';
    if(!deliveryInfo) {
      return <TextLoadingDots textSuffix={'Checking for your delivery details'} />;
    }
    return (
      <div>
        {deliveryInfo.deliveryDate ? <p>Delivery date:   {moment(deliveryInfo.deliveryDate).format('dddd Do MMMM YYYY')}</p> : null}
        {deliveryInfo.deliveryTimeSlot ? <p>Delivery time:  {deliveryInfo.deliveryTimeSlot}</p> : null}
        {orderRef ? <p>Order number:  {orderRef}/{orderNo}</p> : null}
      </div>
    );
  }

  captureBannerVideoClick(content) {
    const gtmEvent = () => {
      const gtmEvent = GTM_SWITCH[this.props.CardName];
      if(gtmEvent && this.props.headerVideoLink) {
        gtmCardEvent(gtmEvent, 'click-video')();
      }
    };
    return (
      <div onClick={gtmEvent}>
        {content}
      </div>
    );
  }

  render() {
    const { title, headerVideoLink, headerImage, headerImageAltText, aboveFoldText = '', belowFoldText,
      hasCta, ctaText, ctaTextAlt, ctaType, ctaLink, headerOverlayText } = this.props;
    const { expanded } = this.state;

    return (
      <div className="u-padding-bottom-small">

        <CardTitlePart title={title} />
        {this.captureBannerVideoClick(
          <CardBannerPart
            imageSrc={headerImage}
            imageAltText={headerImageAltText}
            videoSrc={headerVideoLink}
            videoAltText={headerImageAltText}
            onRef={(ref) => { this.bannerPart = ref; }}
            overlayText={headerOverlayText}
          />
        )}

        {
          !!parseInt(hasCta, 10) ? (
            this.renderCTA(ctaType[0], ctaText, ctaLink, ctaTextAlt)
          ) : null
        }

        <div className="u-padding-x-small u-padding-top-small">
          <HtmlPart htmlString={aboveFoldText} />
          <div className="c-html-part">{this.renderDeliveryInfo()}</div>
        </div>

        {
          expanded ? (
            <div className="u-padding-x-small">
              <HtmlPart htmlString={belowFoldText} />
            </div>
          ) : null
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  userGuid: state.user.userGuid
});

export default connect(mapStateToProps, null)(_DeliveryNoticeCard);



// WEBPACK FOOTER //
// ./src/cards/templates/DeliveryNoticeCard.js